import * as e from "react";
import { p as t } from "./index-efd35e77.js";
import { v as g, c as b, p as M } from "./package-metadata-a152adb8.js";
import { f as y } from "./focus-83744a70.js";
import { g as B } from "./guid-fc0d51fd.js";
import "./index-64063129.js";
var h = e.forwardRef(function(a, c) {
  g(M);
  var l = a.children, i = a.className, r = a.style, n = a.id, s = e.useRef(null), o = e.useCallback(function() {
    s.current && y(s.current);
  }, []), u = e.useCallback(function() {
    return {
      element: s.current,
      focus: o
    };
  }, [o]);
  e.useImperativeHandle(c, u);
  var d = e.useMemo(function() {
    return B();
  }, []), p = e.useMemo(function() {
    return a.themeColor || v.themeColor;
  }, [a.themeColor]), f = e.useMemo(function() {
    return a.position || v.position;
  }, [a.position]), m = e.useMemo(function() {
    return a.positionMode || v.positionMode;
  }, [a.positionMode]), N = e.useMemo(function() {
    return b("k-appbar", {
      "k-appbar-top": f === "top",
      "k-appbar-bottom": f === "bottom",
      "k-appbar-static": m === "static",
      "k-appbar-sticky": m === "sticky",
      "k-appbar-fixed": m === "fixed",
      "k-appbar-light": p === "light",
      "k-appbar-dark": p === "dark",
      "k-appbar-inherit": p === "inherit"
    }, i);
  }, [f, m, p, i]);
  return e.createElement("div", { className: N, style: r, id: n || d }, l);
});
h.propTypes = {
  children: t.any,
  className: t.string,
  style: t.object,
  id: t.string,
  themeColor: t.string,
  position: t.oneOf(["top", "bottom"]),
  positionMode: t.oneOf(["static", "sticky", "fixed"])
};
var v = {
  themeColor: "light",
  position: "top",
  positionMode: "static"
};
h.displayName = "KendoAppBar";
var k = e.forwardRef(function(a, c) {
  var l = a.children, i = a.className, r = a.style, n = e.useRef(null), s = e.useCallback(function() {
    n.current && y(n.current);
  }, []), o = e.useCallback(function() {
    return {
      element: n.current,
      focus: s
    };
  }, [s]);
  e.useImperativeHandle(c, o);
  var u = e.useMemo(function() {
    return b("k-appbar-section", i);
  }, [i]);
  return e.createElement("div", { className: u, style: r }, l);
});
k.propTypes = {
  children: t.any,
  className: t.string,
  style: t.object
};
k.displayName = "KendoAppBarSection";
var C = e.forwardRef(function(a, c) {
  var l = a.children, i = a.className, r = a.style, n = e.useRef(null), s = e.useCallback(function() {
    n.current && y(n.current);
  }, []), o = e.useCallback(function() {
    return {
      element: n.current,
      focus: s
    };
  }, [s]);
  e.useImperativeHandle(c, o);
  var u = e.useMemo(function() {
    return b("k-appbar-spacer", {
      "k-appbar-spacer-sized": r && r.width && r.width !== null
    }, i);
  }, [i, r]), d = e.useMemo(function() {
    return {
      flexBasis: r && r.width ? r.width : void 0
    };
  }, [r]);
  return e.createElement("span", { className: u, style: d }, l);
});
C.propTypes = {
  children: t.any,
  className: t.string,
  style: t.object
};
C.displayName = "KendoAppBarSpacer";
const S = h, x = k, H = C;
export {
  S as AppBar,
  x as AppBarSection,
  H as AppBarSpacer
};
